// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: "Poppins";
  font-size: 14px;
}

#root {
  height: 100%;
  width: 100%;
}

html {
  overflow: hidden;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}

body {
  height: 100%;
  width: 100%;
}
.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.answer_box {
  width: 90%;
  border-radius: 4px;
  border: 1px solid rgba(169, 169, 169, 0.42);
  padding: 4px;
  margin-top: 10px;
}
.App-link {
  color: #61dafb;
}
.multiSelect {
  .ant-select-selection-item{
    background-color: white !important;
  }
}
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.login .ant-drawer-body {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}



/* -------------------------------- start video custom controller----------------------- */
.custom-video-player {
  position: relative;
  width: 100%;
}

.custom-video-player__video {
  width: 100%;
}

.custom-video-player__controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: 5px;
}

.custom-video-player__controls button {
  margin-right: 10px;
}

.custom-video-player__progress-bar {
  flex: 1 1;
  height: 10px;
  background-color: #fff;
  cursor: pointer;
  position: relative;
}

.custom-video-player__progress-bar__progress {
  height: 100%;
  background-color: #00f;
}

.custom-video-player__time {
  margin-left: 10px;
  color: #fff;
}
/* --------------------------------end video custom controller----------------------- */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;AAC3C;;;;AAIA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA,uFAAuF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap\");\n\n.App {\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 14px;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n}\n\nhtml {\n  overflow: hidden;\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n}\n\nbody {\n  height: 100%;\n  width: 100%;\n}\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.answer_box {\n  width: 90%;\n  border-radius: 4px;\n  border: 1px solid rgba(169, 169, 169, 0.42);\n  padding: 4px;\n  margin-top: 10px;\n}\n.App-link {\n  color: #61dafb;\n}\n.multiSelect {\n  .ant-select-selection-item{\n    background-color: white !important;\n  }\n}\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.login .ant-drawer-body {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: space-between !important;\n}\n\n\n\n/* -------------------------------- start video custom controller----------------------- */\n.custom-video-player {\n  position: relative;\n  width: 100%;\n}\n\n.custom-video-player__video {\n  width: 100%;\n}\n\n.custom-video-player__controls {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n\n.custom-video-player__controls button {\n  margin-right: 10px;\n}\n\n.custom-video-player__progress-bar {\n  flex: 1;\n  height: 10px;\n  background-color: #fff;\n  cursor: pointer;\n  position: relative;\n}\n\n.custom-video-player__progress-bar__progress {\n  height: 100%;\n  background-color: #00f;\n}\n\n.custom-video-player__time {\n  margin-left: 10px;\n  color: #fff;\n}\n/* --------------------------------end video custom controller----------------------- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
